import React from "react";
// import Button from "../Button";

// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import KingBedIcon from "@mui/icons-material/KingBed";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  // getCurrencySymbolByCode,
  toPascalCase,
} from "rc-app/utils";

interface PropertyCardProps {
  imageUrl: string;
  className?: string;
  title: string;
  commission?: number;
  bedrooms?: String;
  area?: string | number;
  city?: string;
  contractType?: string;
  price?: number;
  currencySymbol?: string;
  digitalTwinId?: string;
  matterportId?: string;
  exploreButton?: React.ReactNode;
  handleDetailButton?: (digital_twin_id: string, matterport_id: string) => void;
  scrollToTop?: () => void;
}

const NetworkPropertyCardSquare: React.FC<PropertyCardProps> = ({
  imageUrl,
  className,
  exploreButton,
  title,
  commission,
  bedrooms,
  area,
  city,
  contractType,
  price,
  currencySymbol,
  digitalTwinId,
  matterportId,
  handleDetailButton,
  scrollToTop,
  ...props
}) => {
  return (
    <div
      className={`${className} shadow-md rounded-lg`}
      {...props}
      onClick={() => {
        handleDetailButton(digitalTwinId, matterportId);
        scrollToTop();
      }}
    >
      <img
        src={
          imageUrl !== null
            ? imageUrl
            : "https://storage.googleapis.com/opensky-dev/realestate/no_property_image.jpg"
        }
        className={` rounded ${className}`}
        {...props}
      />
      <div className="opacity-1 overflow-hidden bg-white">
        <div className="px-2">
          {!exploreButton && (
            <>
              <h1 className="text-2x1 md:text-[24px] font-semibold text-[#1B191B] text-left py-3 gap-2 hover:text-[#FF307A]">
                {title}
              </h1>
              <div className="grid grid-cols-2  sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-3 gap-1 mb-2">
                <div className="  flex items-center font-semibold">
                  <span className=" text-[#283BBE]">
                    <LocationOnIcon />
                  </span>
                  <span className="ml-1 text-[#010101] xs:text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] xl:text-[17px] ">
                    {toPascalCase(city)}
                  </span>
                </div>
                <div className="  flex  items-center  xs:text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] xl:text-[17px] ">
                  <span className=" text-[#283BBE]">
                    <KingBedIcon />
                  </span>
                  <span className=" ml-1 text-[#010101]  ">
                    {bedrooms} {" Bedrooms"}
                  </span>
                </div>
                <div className=" flex  items-center  xs:text-[8px] sm:text-[10px] md:text-[12px] lg:text-[14px] xl:text-[17px] ">
                  <span className=" text-[#283BBE]">
                    <OpenInFullIcon />
                  </span>
                  <span className="ml-1 text-[#010101]  xl:text-[14px] ">
                    {area}
                  </span>
                </div>
              </div>
            </>
          )}
          {exploreButton && (
            <>
              <h1 className="text-2x1 md:text-[22px] font-semibold text-[#1B191B] text-left py-3 gap-2">
                {title}
              </h1>
              <div className="grid grid-cols-2  sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-2 mb-4">
                <div className=" flex  items-center mb-2  xs:text-[8px] sm:text-[10px] md:text-[10px] lg:text-[12px] xl:text-[14px] ">
                  <span className=" text-[#010101]">
                    <LocationOnIcon className="text-[#283BBE]" />
                  </span>
                  <span className="ml-1 text-[#010101]  xl:text-[14px] ">
                    {city}
                  </span>
                </div>
                <div className="  flex  items-center mb-2  xs:text-[8px] sm:text-[10px] md:text-[10px] lg:text-[12px] xl:text-[14px]">
                  <span className=" text-[#010101]">
                    <KingBedIcon className="text-[#283BBE]" />
                  </span>
                  <span className=" ml-1 text-[#010101]  ">
                    {bedrooms} Rooms
                  </span>
                </div>
                <div className="  flex items-center mb-2 font-semibold xs:text-[8px] sm:text-[10px] md:text-[10px] lg:text-[12px] xl:text-[14px]">
                  <span className=" text-[#010101]">
                    <OpenInFullIcon className="text-[#283BBE]" />
                  </span>
                  <span className="ml-1 text-[#010101] xs:text-[8px] sm:text-[10px] md:text-[10px] lg:text-[12px] xl:text-[14px] ">
                    {area}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        {!exploreButton && (
          <div className="flex mb-4 px-2">
            <div className=" flex items-center  xs:text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[16px]">
              <span className="w-full text-[#001CDD] font-bold ">
                {contractType === "rent"
                  ? "Rent " + currencySymbol + " " + price + "/month"
                  : "Price " + currencySymbol + " " + price}
              </span>
            </div>
          </div>
        )}

        {exploreButton && <div className="flex ">{exploreButton}</div>}
      </div>
    </div>
  );
};

export default NetworkPropertyCardSquare;
